import { createUseStyles } from 'react-jss';

export default createUseStyles({
  modalContentContainer: {
    padding: '48px',
    '@media(max-width: 900px)': {
      padding: '24px',
    }
  },

  header: {
    display: 'flex',
  },

  modalTitle: {
    fontFamily: 'Manrope',
    fontWeight: 'bold',
    fontSize: '24px',
    color: '#102131',
  },

  modalContainer: {
    marginTop: '40px',
    marginBottom: '72px',
  },

  question: {
    display: 'block',
    marginBottom: '32px',
  },

  buttonsFooter: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
  },

  button: {
    width: '180px',
    height: '56px',
    '& > *:first-child': {
      marginTop: '20px',
    },
  },

  input: {
    background: '#F3F6F9',
    borderRadius: '8px',
    padding: '22px 0 22px 22px',
    height: '44px',
    border: '1px solid transparent',
    transition: 'all 0.15s ease-in-out',
    transitionProperty: 'border, background-color',
    '&:focus': {
      border: '1px solid #6A747B',
      backgroundColor: 'white',
    },
    color: '#102131',
  },

  questionInput: {
    width: '100%',
  },

  optionInput: {
    width: '80%',
    marginLeft: '24px',
    transitionProperty: 'border, background-color, boxShadow',
    '&:hover': {
      boxShadow: '0px 8px 32px 4px rgba(16, 33, 49, 0.08)',
    },
    '&:before': {
      content: '"TEST"',
    },
  },

  questionContainer: {
    marginTop: '40px',
    marginBottom: '40px',
  },

  optionsHeader: {
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '16px',
    color: '#102131',
    marginBottom: '16px',
  },

  optionsList: {
    marginBottom: '48px',
    maxHeight: '420px',
    overflowY: 'auto',
    overflowX: 'hidden',
    paddingRight: '4px',
    marginLeft: '-24px',
    position: 'relative',
  },

  option: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',

    '& > div:first-child': {
      position: 'absolute',
      left: '4px',
    },

    '&:not(:hover) > div:first-child': {
      display: 'none',
    },
    '&:focus > div:first-child': {
      display: 'none',
    },
  },

  addAnotherOption: {
    background: 'none',
    border: 'none',
    margin: '0',
    padding: '0',
    cursor: 'pointer',

    fontWeight: '600',
    fontSize: '16px',
    color: '#6D7883',

    marginTop: '36px',
    marginLeft: '24px',

    '&:hover': {
      textDecoration: 'underline',
      color: '#909BA6',
    },
  },

  gradeZone: {
    display: 'flex',
    marginBottom: '48px',
    justifyContent: 'space-between',
  },

  gradeInput: {
    padding: '18px 0 18px 18px',
    maxWidth: '120px',
  },

  stars: {
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    width: '200px',
  },

  handlerContainer: {
    width: '13px',
    height: '23px',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'space-between',
  },

  handlerPoint: {
    width: '3px',
    height: '3px',
    boxSizing: 'border-box',
    backgroundColor: '#B2B9C0',
    border: '1px solid #B2B9C0',
    borderRadius: '50%',
    marginRight: '3px',
  },

  inputSign: {
    position: 'absolute',
    right: '20%',
    width: '32px',
    height: '32px',
    border: '1px solid #B2B9C0',
    boxSizing: 'border-box',
  },

  singleSign: {
    borderRadius: '50%',
  },

  multipleSign: {
    borderRadius: '6px',
  },
});
